var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00495 6.3355L12.2082 0.214844C12.4786 -0.0665116 12.9168 -0.0665116 13.1873 0.214844C13.4577 0.496388 13.4577 0.953002 13.1873 1.23434L7.57072 7.78523C7.41626 7.94611 7.20685 8.01503 7.00519 7.99199C6.80352 8.01503 6.59411 7.94611 6.43966 7.78523L0.81201 1.29327C0.541604 1.01192 0.541604 0.55531 0.81201 0.273775C1.08242 -0.00757994 1.52068 -0.00757994 1.79109 0.273775L7.00495 6.3355Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.edf479684fc1d486a699110b45d1139e.svg";
export { ForwardRef as ReactComponent };